document.addEventListener('DOMContentLoaded', function() {
    // Select the registration form (assuming class="login--register")
    var registerForm = document.querySelector('form.login--register');
    if (registerForm) {
        // Build the URL without query parameters.
        // E.g. https://allagri.test/my-account
        var newAction = window.location.origin + window.location.pathname;

        // If you have a custom site url structure or subdirectory, ensure this matches your logic:
        // e.g. newAction = window.location.protocol + '//' + window.location.host + window.location.pathname;

        // Set the form to post to the "clean" URL (no query params).
        registerForm.setAttribute('action', newAction);
    }
});